export default __webpack_public_path__ + "static/media/pinterest.77070ab0.svg";